import React, { useEffect, useState, useRef } from "react";
import ClearIcon from '@mui/icons-material/Clear';

import { ValidateInput } from "../../utilities";
import "./style.css";
import { MenuItem, Select } from "@mui/material";

function CustomizedSelectDropdown(props) {
    const {
        label,
        liste_valeurs,
        name,
        required,
        error,
        schema
    } = props

    const dropDownRef = useRef()
    const textAreaRef = useRef()
    const textAreaContainerRef = useRef()

    const [showDropDown, setShowDropDown] = useState(true)
    const [isValid, setIsValid] = useState(!error)
    const [state, setState] = useState("")

    const validateInput = (e) => {
        setState(e.target.value)

        const valid = ValidateInput(schema, { [name]: e.target.value })
        setIsValid(valid)

        textAreaContainerRef.current.style.visibility = "visible"
        textAreaContainerRef.current.style.width = "100%"
        textAreaContainerRef.current.style.height = "auto"
        textAreaContainerRef.current.style.minHeight = "50px"
        textAreaContainerRef.current.style.removeProperty('padding')
        textAreaContainerRef.current.style.removeProperty('margin')

        dropDownRef.current.style.visibility = "hidden"
        dropDownRef.current.style.width = 0
        dropDownRef.current.style.height = 0
        setShowDropDown(false)
    }

    const handleOpenOption = (e) => {
        textAreaRef.current.style.height = 0
        setState("")

        dropDownRef.current.style.visibility = "visible"
        dropDownRef.current.style.width = "100%"
        dropDownRef.current.style.height = "50px"

        textAreaContainerRef.current.style.visibility = "hidden"
        textAreaContainerRef.current.style.width = 0
        textAreaContainerRef.current.style.height = 0
        textAreaContainerRef.current.style.minHeight = 0
        textAreaContainerRef.current.style.padding = 0
        textAreaContainerRef.current.style.margin = 0
        setShowDropDown(true)

        dropDownRef.current.focus()
    }

    useEffect(() => {
        textAreaRef.current.style.height = textAreaRef.current.scrollHeight + "px"
    }, [textAreaRef, state])

    useEffect(() => {
        setIsValid(!error)
    }, [error])

    useEffect(() => {
        textAreaContainerRef.current.style.width = 0
        textAreaContainerRef.current.style.height = 0
        textAreaContainerRef.current.style.minHeight = 0
        textAreaContainerRef.current.style.padding = 0
        textAreaContainerRef.current.style.margin = 0
    }, [])

    const option = liste_valeurs.split(";")

    return <div className={`form-group form-element ${!isValid ? "error" : ""}`}>
        <div>
            <label htmlFor={name}>{label} {required ? <span className='text-danger'>*</span> : null}</label>
        </div>
        <div>
            <Select ref={dropDownRef} name={name} id={name} className="form-control" onChange={validateInput} value={state} style={{ visibility: "visible" }}>
                {option.map((o, index) => {
                    return  o.length > 0
                            ? 
                            <MenuItem style={{ whiteSpace: 'pre-wrap', borderBottom: index !== option.length - 1 ? '1px solid #ccc' : '', }} value={o}>
                                {o}
                            </MenuItem>
                            :
                            <></>
                })}
            </Select>
            <div ref={textAreaContainerRef} className="large-dropdown" style={{ visibility: "hidden" }}>
                <textarea ref={textAreaRef} rows={1} disabled className="form-control" value={state} onChange={validateInput}></textarea>
                {!showDropDown ? <ClearIcon sx={{ color: "black" }} onClick={handleOpenOption} /> : null}
            </div>
        </div>
    </div>
}

export default CustomizedSelectDropdown;